import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Column = styled.div`
  &:first-child {
    div {
      &:first-child {
        border-top-left-radius: 6px;
      }
      &:last-child {
        border-bottom-left-radius: 6px;
      }
    }
  }

  &:last-child {
    div {
      &:first-child {
        border-top-right-radius: 6px;
      }
      &:last-child {
        border-bottom-right-radius: 6px;
      }
    }
  }
`;
